import dayjs from 'dayjs'

// Classe centralizadora da obtenção de datas e horários
export class Time {
  static get week_day() {
    return Time.getInstance().day()
  }

  /**
   *
   * @param  {...any} args
   * @returns {dayjs.Dayjs}
   */
  static getInstance(...args) {
    return dayjs(...args)
    // .set('hour', 0)
    // .set('minute', 15);
  }

  static format(format) {
    return Time.getInstance().format(format)
  }

  static getDate(date) {
    return Time.getInstance(date)
  }
}
